
import { useRef, useState, Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import Brisket from '../assets/brisket.webp'
import Tritip from '../assets/tritip.webp'
import PulledPork from '../assets/pulledPork.webp'
import { useScroll, motion } from 'motion/react';
import { PerspectiveSection } from '../components/animated-elements/PerspectiveSection';
import Image1 from  '../assets/cc-beards-event/1.webp'
import Image2 from  '../assets/cc-beards-event/2.webp'
import Image3 from  '../assets/cc-beards-event/3.webp'
import Image4 from  '../assets/cc-beards-event/4.webp'
import Image5 from  '../assets/cc-beards-event/5.webp'
import Image6 from  '../assets/cc-beards-event/6.webp'
import Image7 from  '../assets/cc-beards-event/7.webp'
import Image8 from  '../assets/cc-beards-event/8.webp'
import Image9 from  '../assets/cc-beards-event/9.webp'
import Image10 from  '../assets/cc-beards-event/10.webp'
import Image11 from  '../assets/cc-beards-event/11.webp'
import Image12 from  '../assets/cc-beards-event/12.webp'
import Image13 from  '../assets/cc-beards-event/13.webp'
import Image14 from  '../assets/cc-beards-event/14.webp'
import Image15 from  '../assets/cc-beards-event/15.webp'
import Image16 from  '../assets/cc-beards-event/16.webp'
import Image17 from  '../assets/cc-beards-event/17.webp'
import Image18 from  '../assets/cc-beards-event/18.webp'
import Image19 from  '../assets/cc-beards-event/19.webp'
import Image20 from  '../assets/cc-beards-event/20.webp'
import Video1 from '../assets/cc-beards-event/testimonials/t1.webm'
import Video2 from '../assets/cc-beards-event/testimonials/t2.webm'
import Video3 from '../assets/cc-beards-event/testimonials/t3.webm'
import Video4 from '../assets/cc-beards-event/testimonials/t4.webm'
import Video5 from '../assets/cc-beards-event/testimonials/t5.webm'
import Video6 from '../assets/cc-beards-event/testimonials/t6.webm'
import Video7 from '../assets/cc-beards-event/testimonials/t7.webm'
import Video8 from '../assets/cc-beards-event/testimonials/t8.webm'
import Video9 from '../assets/cc-beards-event/testimonials/t9.webm'
import Video10 from '../assets/cc-beards-event/testimonials/t10.webm'

import CharcoalBG from '../assets/charcoal-bed.webp'
import Carousel from 'react-multi-carousel';
import styles from '../components/yelp-reviews/YelpReview.module.css'

export interface Testimonal {
    name?: string,
    comment?: string,
    image?: string,
    video?: string
}


const photos: Testimonal[] = [
   
     {
        name: "",
        comment: "Blazing fire",
        image: Image1,
        video: ""
    },
    {
        name: "",
        comment: "Burning bed of charcoals",
        image: Image2,
        video: ""
    },
    {
        name: "",
        comment: "Grillmaster Grigor standing by fire smiling",
        image: Image3,
        video: ""
    },
    {
        name: "",
        comment: "Grigor and Harry smiling and giving thumbs up from an aerial view",
        image: Image4,
        video: ""
    },
    {
        name: "",
        comment: "Grigor and Harry skewering meats",
        image: Image5,
        video: ""
    },
    {
        name: "",
        comment: "Grigor cooking pork belly",
        image: Image6,
        video: ""
    },
    {
        name: "",
        comment: "Side view of cooking pork belly",
        image: Image7,
        video: ""
    },
    {
        name: "",
        comment: "Side view of cooking pork belly from farther away",
        image: Image8,
        video: ""
    },
    {
        name: "",
        comment: "Grigor turning skewers, plumes of smoke rising from pork belly fat dripping on fire",
        image: Image9,
        video: ""
    },
    {
        name: "",
        comment: "Matt holding a margarita with a small umbrella placed in the cup, the grill blurry and visible in the background",
        image: Image10,
        video: ""
    },
    {
        name: "",
        comment: "Pork belly sitting on foil waiting to be pulled into serving bins",
        image: Image11,
        video: ""
    },
    {
        name: "",
        comment: "Patrons ladeling food into plates",
        image: Image12,
        video: ""
    },
    {
        name: "",
        comment: "Over the shoulder view of a plate of food containing rice, cabbage salad, lavash and pork belly",
        image: Image13,
        video: ""
    },
    {
        name: "",
        comment: "More guests filling plates with food",
        image: Image14,
        video: ""
    },
    {
        name: "",
        comment: "Three ladies enjoying barbecue and conversing",
        image: Image15,
        video: ""
    },
    {
        name: "",
        comment: "Patron using tongs to grab Grilled Ranchero Beef",
        image: Image16,
        video: ""
    },
    {
        name: "",
        comment: "Delicious tray of food containging grilled chicken topped with tzatziki, and rice and herb stuffed sweet pepper dolma",
        image: Image17,
        video: ""
    },
    {
        name: "",
        comment: "Close up of carrot and cabbage salad",
        image: Image18,
        video: ""
    },
    {
        name: "",
        comment: "Close up of rice and herb stuffed sweet pepper dolma",
        image: Image19,
        video: ""
    },
    {
        name: "",
        comment: "Patrons filling plates with veggie options",
        image: Image20,
        video: ""
    },
]


const videos = [
    Video3,
    Video4,
    Video7,
    Video8,
    Video9,
    Video10,
    Video1,
    Video2,
    Video5,
    Video6,
   
]

export default function TestimonialsPage() {

    const responsive = {
        desktop: {
        breakpoint: { max: 5120, min: 1200 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
        breakpoint: { max: 1200, min: 800 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
        breakpoint: { max: 800, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
        }
    };


    return (
        <Grid container  sx={{ paddingTop: '100px', height: '100vh', position: 'relative',  justifyContent: 'center', alignItems: 'center', margin: 'auto', padding: 'auto', maxWidth:'1920px' }} >
             <Grid item xs={12} mb="80px">
                <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    ssr={false} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    keyBoardControl={true}
                    customTransition="all 500ms ease-in-out"
                    transitionDuration={500}
                    itemClass={styles.YelpSlide}
                    containerClass={styles.YelpCarousel}
                    // removeArrowOnDeviceType={["tablet", "mobile"]}
                    // deviceType={this.props.deviceType}
                    dotListClass={styles.DotList}
                >
                    {photos.map( (photo, index) =>
                        <Grid container key={index} sx={{ height:'100%', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                            <Grid item >
                                <img key={`${index}-ps-image`} src={photo.image} alt={photo.comment} style={{ height: 'auto', width: '100%', maxWidth: '1000px', maxHeight: '75vh' }}/>
                            </Grid>
                        </Grid>
                    )}
                </Carousel>
             </Grid>
             <Grid item xs={12} textAlign='center' pb='20px'>
                <Typography variant='h2' sx={{color: 'white'}}>
                    Testimonials
                </Typography>
                <Typography sx={{color: 'white'}}>
                    Diners were asked what they thought of the food!
                </Typography>
             </Grid>
             <Grid item xs={12} pb="100px">
                <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    ssr={false} // means to render carousel on server-side.
                    infinite={false}
                    autoPlay={false}
                    keyBoardControl={true}
                    customTransition="all 500ms ease-in-out"
                    transitionDuration={500}
                    itemClass={styles.YelpSlide}
                    containerClass={styles.YelpCarousel}
                    // removeArrowOnDeviceType={["tablet", "mobile"]}
                    // deviceType={this.props.deviceType}
                    dotListClass={styles.DotList}
                >
                    {videos.map( (video, index) =>
                        <Grid container key={`testimonial-${index}`} sx={{ height:'100%', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                            <Grid item sx={{filter: 'drop-shadow(0px 0px 10px black)'}}>
                                <video controls={true} key={`${index}-ps-image`} src={video}  style={{ height: 'auto', width: '100%', maxWidth: '1000px', maxHeight: '75vh' }}/>
                            </Grid>
                        </Grid>
                    )}
                </Carousel>

             </Grid>
            
            
            {/* <PerspectiveSection key={index} scrollYProgress={scrollYProgress} index={index} numElements={content.length} {...testimonial} />
            <div key={`${index}-padding`} style={{height: '50vh', width: '100vw'}}/> */}
      </Grid>
  );
}

